import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { PairIconSkeleton } from '@root/entities/pair/ui/pair-icon-skeleton'
import { Separator } from '@root/shared/ui-kit'

export const PairInformationShortSkeleton: React.FC = () => (
  <Root>
    <PairIconSkeleton size={36} />
    <Currency>
      <Skeleton height={12} width={100} />
      <Skeleton height={8} width={150} />
    </Currency>
    <Pool>
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
      <Separator vertical />
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
      <Separator vertical />
      <PoolItem>
        <Skeleton height={6} />
        <Skeleton height={10} />
      </PoolItem>
    </Pool>
  </Root>
)

const Root = styled.div`
  border-bottom: 1px solid var(--background-2);

  height: 60px;
  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  padding-inline: 12px 16px;
`

const Currency = styled.div`
  display: grid;

  margin-inline-start: 6px;
  gap: 4px;
`

const Pool = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  justify-self: end;
  gap: 14px;

  align-items: center;
`

const PoolItem = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;

  gap: 4px;
  width: 50px;
`
